import type { SectionedChecklistSection } from 'v5/patterns/widgets/SectionedChecklist';

/** The line's key among the picked ones: a number, which no field key (a string) can be. */
export const DIVIDER_KEY = -1;

/** The sections with the items whose label contains `query`. */
export function filterSections(
  sections: ReadonlyArray<SectionedChecklistSection>,
  query: string
): SectionedChecklistSection[] {
  const needle = query.trim().toLocaleLowerCase();
  if (needle === '') return [...sections];
  return sections
    .map(section => ({
      ...section,
      items: section.items.filter(item =>
        item.label.toLocaleLowerCase().includes(needle)
      )
    }))
    .filter(section => section.items.length > 0);
}

export const fieldOrderUtils = {
  /** The picked keys with the line after the first `at` of them. */
  withDivider: (
    picked: ReadonlyArray<string>,
    at: number
  ): Array<string | typeof DIVIDER_KEY> => [
    ...picked.slice(0, at),
    DIVIDER_KEY,
    ...picked.slice(at)
  ],
  /** The list after a drag: the picked ones in order and how many sit above the line. */
  split: (
    orderedKeys: ReadonlyArray<string | number>
  ): { picked: string[]; dividerAt: number } => {
    const picked = orderedKeys.filter(
      (key): key is string => typeof key === 'string'
    );
    const at = orderedKeys.indexOf(DIVIDER_KEY);
    return { picked, dividerAt: at === -1 ? picked.length : at };
  }
};
